import React from 'react';

import { SplitFlapDigit } from './splitFlapDigit';

import './timer.css';

class Timer extends React.Component {
    constructor() {
        super();
        this.state = {
            days: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
        this.timer = 0;
        this.countdown = this.countdown.bind(this);
    }

    countdown() {
        let Difference_In_Time = this.props.date - new Date().getTime();
        let Difference_In_Days = Math.floor(
            Difference_In_Time / (1000 * 3600 * 24)
        );

        let leftover =
            (Difference_In_Time - Difference_In_Days * (1000 * 3600 * 24)) /
            1000;
        let hours = Math.floor(leftover / (60 * 60));

        let divisor_for_minutes = leftover % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);
        if (seconds === 60) {
            seconds = 0;
        }

        this.setState({
            days: Difference_In_Days,
            hours,
            minutes,
            seconds,
        });
    }

    componentDidMount() {
        if (
            this.state.days > 0 ||
            this.state.hours > 0 ||
            this.state.minutes > 0 ||
            this.state.seconds > 0
        ) {
            this.timer = setInterval(this.countdown, 1000);
        } else {
            clearInterval(this.timer);
        }
    }

    render() {
        let days =
            (this.state.days < 100 ? '0' : '') +
            (this.state.days < 10 ? '0' : '') +
            this.state.days.toString();
        let hours =
            (this.state.hours < 10 ? '0' : '') + this.state.hours.toString();
        let minutes =
            (this.state.minutes < 10 ? '0' : '') +
            this.state.minutes.toString();
        let seconds =
            (this.state.seconds < 10 ? '0' : '') +
            this.state.seconds.toString();
        return (
            <div>
                <div className="mainCountdownContainer">
                    <div className="countdownHolder">
                        <span
                            aria-hidden="true"
                            className="countDownText daysCounter"
                        >
                            {days.split('').map((iNum, index) => {
                                return (
                                    // <span className="digitBox" key={index}>
                                    //     {iNum}
                                    // </span>
                                    <SplitFlapDigit
                                        key={`d${index}`}
                                        value={iNum}
                                    />
                                );
                            })}
                        </span>
                        <span
                            aria-hidden="true"
                            className="countDownText hoursCounter"
                        >
                            {hours
                                .toString()
                                .split('')
                                .map((iNum, index) => {
                                    return (
                                        // <span className="digitBox" key={index}>
                                        //     {parseInt(iNum, 10)}
                                        // </span>

                                        <SplitFlapDigit
                                            key={`h${index}`}
                                            value={parseInt(iNum, 10)}
                                        />
                                    );
                                })}
                        </span>
                        <span
                            aria-hidden="true"
                            className="countDownText minutesCounter"
                        >
                            {minutes
                                .toString()
                                .split('')
                                .map((iNum, index) => {
                                    return (
                                        // <span className="digitBox" key={index}>
                                        //     {parseInt(iNum, 10)}
                                        // </span>
                                        <SplitFlapDigit
                                            key={`m${index}`}
                                            value={parseInt(iNum, 10)}
                                        />
                                    );
                                })}
                        </span>
                        <span
                            aria-hidden="true"
                            className="countDownText secondsCounter"
                        >
                            {seconds
                                .toString()
                                .split('')
                                .map((iNum, index) => {
                                    return (
                                        // <span className="digitBox" key={index}>
                                        //     {parseInt(iNum, 10)}
                                        // </span>
                                        <SplitFlapDigit
                                            key={`s${index}`}
                                            value={parseInt(iNum, 10)}
                                        />
                                    );
                                })}
                        </span>
                    </div>
                </div>
                <div className="labelHolder" aria-hidden="true">
                    <span className="dayLabelHolder">Days</span>
                    <span className="hourLabelHolder">Hours</span>
                    <span className="minuteLabelHolder">Mins</span>
                    <span className="secondLabelHolder">Secs</span>
                </div>
            </div>
        );
    }
}

export default Timer;
